import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { Revision, RevisionPrompt } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'

interface Props {
  articleKey: string
  layerId: string
}

export interface Data {
  revision: Revision
}

export interface Selection {
  type: 'all' | 'text' | 'node'
  anchor?: number
  head?: number
}

export interface Variables {
  prompt: RevisionPrompt
  selection: Selection
  documentAsMarkdown: string
  selectionAsMarkdown: string
  previousRevisionId?: string
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const useCreateRevision = ({ articleKey, layerId }: Props, options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    'createLayer',
    async ({ prompt, selection, documentAsMarkdown, selectionAsMarkdown, previousRevisionId }) => {
      const response = await sendToApi<Data>(`/articles/${articleKey}/layers/${layerId}/ai_revisions`, {
        method: 'POST',
        body: {
          selection,
          document_as_markdown: documentAsMarkdown,
          selection_as_markdown: selectionAsMarkdown,
          prompt,
          previous_revision_id: previousRevisionId,
          with_images: false,
        },
      })
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
          'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      return response.data
    },
    {
      ...options,
    },
  )
}
